import Footer from "../../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import { Edit, Trash2 } from "react-feather";

function AdminBookingReport() {
  const bookingData = [
    {
      id: 1,
      customerName: "John Doe",
      bookingBy: "Agent A",
      bookingDate: "2025-01-01",
      from: "New York",
      to: "Paris",
      bookingId: "BK001",
      invoice: "INV001",
      departureDate: "2025-01-15",
    },
    {
      id: 2,
      customerName: "Jane Smith",
      bookingBy: "Agent B",
      bookingDate: "2025-01-02",
      from: "London",
      to: "Rome",
      bookingId: "BK002",
      invoice: "INV002",
      departureDate: "2025-01-20",
    },
    {
      id: 3,
      customerName: "Mike Johnson",
      bookingBy: "Agent C",
      bookingDate: "2025-01-03",
      from: "Tokyo",
      to: "Seoul",
      bookingId: "BK003",
      invoice: "INV003",
      departureDate: "2025-01-25",
    },
  ];

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <div className="text-start mb-3">
                <span className="btn3 me-2 txt71">Booking Report</span>
                <span className="btn3 me-2 txt71">Transaction Report</span>
                <span className="btn3 me-2 txt71">Staff/Employee Report</span>
                <span className="btn3 me-2 txt71">Customer Report</span>
                <span className="btn3 me-2 txt71">Agent/ Distributor Report</span>
                <span className="btn3 me-2 txt71">Cancelation Report</span>
                {/* <span className="btn3 me-2 txt71">Cancelation Report</span> */}
              </div>

              <div className="crdmain mb-2">
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ width: "100%" }}
                >
                  <h2 className="chart-title mb-0">Booking Report</h2>
                </div>

                <div className="row g-2 mt-0 mb-0">
                  <div className="col-md-12 p-2">
                    {/* Table */}
                    <div className="table-responsive classic-table">
                      <table className="table table-striped table-hover">
                        <thead className="table-header">
                          <tr>
                            <th>#</th>
                            <th>Customer Name</th>
                            <th>Booking By</th>
                            <th>Booking Date</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Booking ID</th>
                            <th>Invoice</th>
                            <th>Departure Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookingData.map((booking, index) => (
                            <tr key={booking.id}>
                              <td>{index + 1}</td>
                              <td>{booking.customerName}</td>
                              <td>{booking.bookingBy}</td>
                              <td>{booking.bookingDate}</td>
                              <td>{booking.from}</td>
                              <td>{booking.to}</td>
                              <td>{booking.bookingId}</td>
                              <td>{booking.invoice}</td>
                              <td>{booking.departureDate}</td>
                              <td>
                                <span className="btn2 me-2" title="Edit">
                                  <Edit size={15} />
                                </span>
                                <span className="btn2" title="Delete">
                                  <Trash2 size={15} />
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminBookingReport;
